import { render, staticRenderFns } from "./SignerAuthIndicator.vue?vue&type=template&id=9079f602&scoped=true&"
import script from "./SignerAuthIndicator.vue?vue&type=script&lang=ts&"
export * from "./SignerAuthIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./SignerAuthIndicator.vue?vue&type=style&index=0&id=9079f602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9079f602",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VSpacer})
